export enum E_SEW_BUTTON_HIERARCHY {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}

export enum E_SEW_BUTTON_SIZE {
    XXXS = 'xxxs',
    XXS = 'xxs',
    XS = 'xs',
    S = 's',
    M = 'm',
}
